import React from "react";

const FVFRFleetSpec = ({
  title,
  description,
  image,
  imageAlt,
  refrigerationRows,
  payloadRows,
  note,
}) => {
  return (
    <section className="fvfr-fleet-spec-section">
      <div className="container">
        <div className="row align-items-stretch g-5">
          <div
            className="col-md-4 fvfr-fleet-img-col"
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <img
              src={image}
              alt={imageAlt}
              className="fvfr-fleet-img"
              loading="lazy"
            />
          </div>

          <div
            className="col-md-8"
            data-aos="fade-left"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <h2 className="h2-title mb-3">{title}</h2>
            <p className="fvfr-fleet-desc">{description}</p>

            <p className="fvfr-spec-table-title">Refrigeration System Specifications</p>
            <div className="table-responsive mb-4">
              <table className="fvfr-spec-table">
                <thead>
                  <tr>
                    <th>Specification</th>
                    <th>Detail</th>
                  </tr>
                </thead>
                <tbody>
                  {refrigerationRows.map((row, i) => (
                    <tr key={i}>
                      <td><strong>{row.spec}</strong></td>
                      <td>{row.detail}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="fvfr-spec-table-title">Payload &amp; Load Configuration</p>
            <div className="table-responsive mb-4">
              <table className="fvfr-spec-table">
                <thead>
                  <tr>
                    <th>Specification</th>
                    <th>Detail</th>
                  </tr>
                </thead>
                <tbody>
                  {payloadRows.map((row, i) => (
                    <tr key={i}>
                      <td><strong>{row.spec}</strong></td>
                      <td>{row.detail}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {note && <p className="fvfr-spec-note">{note}</p>}

            <div className="d-flex flex-wrap gap-3 mt-4">
              <a href="tel:+971544792905" className="mini-btn primary">
                Call Now
              </a>
              <a
                href="https://wa.me/971544792905"
                target="_blank"
                rel="noopener noreferrer"
                className="mini-btn secondary-dark"
              >
                WhatsApp Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FVFRFleetSpec;
